import {push} from '@raison/navigation';
import {EntityId} from '@reduxjs/toolkit';
import {OperableAccount, OperableTarget, OperationModel} from './domain';

type OperationAsParameters = [
    type: OperationModel.Type,
    account: {
        id: EntityId;
        type: OperableAccount.Type;
    },
    target: {
        id: EntityId;
        type: OperableTarget.Type;
    } | null,
];

export const createOperationRoute = (...args: OperationAsParameters | [operation: OperationModel]): string => {
    if (args.length === 1) {
        const {type, account, target} = args[0];
        return `/operation/${createRelativeOperationRoute(type, account, target)}`;
    } else {
        return `/operation/${createRelativeOperationRoute(...args)}`;
    }
};

export const createRelativeOperationRoute: (...args: OperationAsParameters) => string = (type, account, target) => {
    if (target === null) {
        return `${type}/${account.type}/${account.id}`;
    } else {
        return `${type}/${account.type}/${account.id}/${target.type}/${target.id}`;
    }
};

export const goToOperation = (operation: OperationModel.Identity) => {
    const route = createOperationRoute(operation.type, operation.account, operation.target);
    return push(route);
};
